import { useContext, useMemo } from 'react'

import { EDITOR_TOOLS, TEMP_COMMENT_ID } from '@editor/config/constants'
import { EditorContext } from '@editor/contexts/Editor'
import { CanvasConfig } from '@editor/interfaces/editor'
import {
  modifyComment,
  setEditingComment,
  setFormImages,
  setSelectedComment,
} from '@editor/pages/projects/common/Comments/store/comments'
import { RootState, useAppDispatch } from '@editor/store/app'
import { useSelector } from 'react-redux'

export default function useMainCanvas(): CanvasConfig {
  // Context
  const { selectedTool } = useContext(EditorContext)

  // Store
  const dispatch = useAppDispatch()
  const inspectionArea = useSelector((state: RootState) => state.page.inspectionArea)
  const user = useSelector((state: RootState) => state.user.user)
  const editingCommentId = useSelector((state: RootState) => state.comments.editingCommentId)
  const selectedComment = useSelector((state: RootState) => state.comments.selectedComment)

  // Vars
  const isSelectedTool = useMemo(() => selectedTool === EDITOR_TOOLS.COMMENT, [selectedTool])

  return {
    events: {
      onMouseUp: (ev, point, solidMeshPoint, { isDragged }) => {
        if (!isSelectedTool || isDragged || !point || !inspectionArea) return

        const newPosition = { x: point[0], y: point[1], z: point[2] }
        // Update the editing comment's position
        if (editingCommentId && editingCommentId !== TEMP_COMMENT_ID) {
          dispatch(
            modifyComment({
              thread_id: editingCommentId,
              cartesian_position: newPosition,
            }),
          )
        }
        // Add new comment
        else if (!selectedComment) {
          const dummyComment = {
            thread_id: TEMP_COMMENT_ID,
            author_name: user?.nickname || '',
            thread_body: '',
            cartesian_position: newPosition,
            inspection_area_id: inspectionArea.inspection_area_id,
          }
          dispatch(setEditingComment(dummyComment))
          dispatch(setSelectedComment(dummyComment))
          dispatch(setFormImages([]))
        }
      },
    },
  }
}
